import React, { createContext, useContext, useState, useCallback } from "react";
import axios from "axios";
import { CHAPTERS } from "../data/content";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const AccessCtx = createContext(null);

// The first three sections (00, 01, 02) are free; everything after is gated.
const FREE_COUNT = 3;

export function isGated(chapterId) {
  const idx = CHAPTERS.findIndex((c) => c.id === chapterId);
  return idx >= FREE_COUNT;
}

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function AccessProvider({ children }) {
  const [email, setEmail] = useState(() => localStorage.getItem("mla_email") || "");
  const [error, setError] = useState("");
  const unlocked = !!email;

  const submitEmail = useCallback(async (raw) => {
    const value = (raw || "").trim().toLowerCase();
    if (!EMAIL_RE.test(value)) {
      setError("Please enter a valid email address.");
      return false;
    }
    setError("");
    localStorage.setItem("mla_email", value);
    setEmail(value);
    const sessionId = localStorage.getItem("mla_session_id");
    axios.post(`${API}/leads`, { email: value, session_id: sessionId }).catch(() => {});
    return true;
  }, []);

  return (
    <AccessCtx.Provider value={{ email, unlocked, error, submitEmail }}>
      {children}
    </AccessCtx.Provider>
  );
}

export function useAccess() {
  return useContext(AccessCtx);
}
